export const stripUsernameChars = (val, callback) => {
    callback(val.replace(/[^a-zA-Z\-0-9]+/g, ''));
}
